'use strict';
const angular = require('angular');
import LoginController from './login.controller';

export default angular.module('nomasvelloDashboardApp.login', [])
  .controller('LoginController', LoginController)
  .name;



// WEBPACK FOOTER //
// ./client/app/account/login/index.ts